<template>
  <section class="allies">
    <h2>ALIADOS</h2>
    <div class="logos-container">
      <img
        class="andes"
        src="@/assets/images/logo_andes.png"
        alt="DiDi Shark Tank"
      />
      <img
        class="sony"
        src="@/assets/images/logo_sony.png"
        alt="DiDi Shark Tank"
      />
    </div>
  </section>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.allies {
  width: 80%;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: white;
  margin-bottom: 8rem;

  h2 {
    font-family: "Montserrat", sans-serif;
    margin-bottom: 2rem;
  }

  .logos-container {
    display: flex;
    justify-content: center;
    align-items: center;

    .andes {
      width: 180px;
      margin-right: 4rem;
    }

    .sony {
      width: 100px;
    }
  }
}
</style>